<template>
  <ClientOnly>
    <div
      v-if="show"
      class="cookie-wrapper"
    >
      <CookieManagement />
    </div>
  </ClientOnly>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  ref,
} from '#imports'
import CookieManagement from '@/components/CookieManagement.vue'
import {
  getCookie,
  isPikPakClient,
} from '@/utils'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

const hiddenRouteNames = ['loading'] // 需要隐藏的路由名
const route = useRoute()
const isApp = ref(false)// 判断是否是app内嵌页
const hasCookie = ref(false)// cookie中是否存在allow_analysis
const show = computed(() => !isApp.value && !hasCookie.value && !hiddenRouteNames.includes(route.name as string))

onMounted(() => {
  isApp.value = isPikPakClient()
  hasCookie.value = !!getCookie('allow_analysis')
})
</script>

<style
  lang="less"
  scoped
>
.cookie-wrapper {
  position: fixed;
  z-index: 999;
  bottom: 48px;
  left: 48px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  max-width: calc(100% - 96px);
  @media screen and (max-width: 640px) {
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 48px);
    max-width: calc(100% - 48px);
  }
}
</style>
